// Vite entry point.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// W40.2 (2026-10-21): reset.css goes FIRST so its `@layer chrome, screen,
// parity;` statement fixes the layer order before any screen sheet
// (imported by App) reaches the bundle.
import './styles/reset.css';
import { App } from './App.js';
// W40 (2026-10-21): the shared-shell parity sheet is the LAST stylesheet in
// the bundle and (W40.2) the last cascade layer, so it outranks every
// per-screen sheet (see the file header).
import './styles/shell-parity.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element with id "root" was not found in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
